import React, { useEffect, useState } from 'react';
import { AttachmentsManager } from '../../components/Attachments/AttachmentsManager';
// Assets, templates, brand colors removed in post-refactor cleanup
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button/Button';
import { Container } from '../../components/ui/Container/Container';
import { Grid, GridItem } from '../../components/ui/Grid/Grid';
import { EventsService, EventWithClientDTO } from '../../services/EventsService';

export function DashboardPage() {
	const navigate = useNavigate();
	const location = useLocation();
	const [showAttachmentsManager, setShowAttachmentsManager] = useState(false);
	const [events, setEvents] = useState<EventWithClientDTO[]>([]);
	const [loadingEvents, setLoadingEvents] = useState(true);
	// Assets, templates, AI generator, drafts removed in post-refactor cleanup

	// Open modals based on the current route path
	useEffect(() => {
		const p = location.pathname;
		setShowAttachmentsManager(p === '/attachments');
	}, [location.pathname]);

	// Fetch events on component mount
	useEffect(() => {
		const fetchEvents = async () => {
			try {
				const eventsService = new EventsService();
				const eventsData = await eventsService.listAll();
				setEvents(eventsData);
			} catch (error) {
				console.error('Failed to fetch events:', error);
			} finally {
				setLoadingEvents(false);
			}
		};

		fetchEvents();
	}, []);

		return (
		<div className="min-h-[calc(100vh-64px)] w-full" style={{ backgroundColor: '#efede7' }}>
			<Container size="xl" className="py-8">
				{/* Welcome Section */}
				<div className="mb-10">
					<h1 className="text-3xl font-bold mb-2" style={{ color: 'rgb(38, 76, 81)' }}>Welcome back!</h1>
					<p className="text-lg" style={{ color: 'rgb(38, 76, 81)' }}>Moniker's internal platform for tools, automations, and AI-driven operations</p>
				</div>

			{/* Main Modules */}
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
				{/* Flight Cost Assessment Tool */}
				<div className="rounded-2xl p-8 shadow-xl flex flex-col" style={{ backgroundColor: 'rgb(38, 76, 81)', color: '#ffffff' }}>
					<div className="flex items-start gap-3 mb-6 flex-1">
						<div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
							<svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: '#ffffff' }}>
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
							</svg>
						</div>
						<div>
							<h2 className="text-2xl font-bold mb-2" style={{ color: '#ffffff' }}>Flight Cost Assessment Tool</h2>
							<p style={{ color: '#ffffff' }}>Estimate flight costs for your travel planning</p>
						</div>
					</div>
					<button 
						onClick={() => navigate('/tools/flight-cost')} 
						className="w-full bg-white/10 rounded-xl px-4 py-3 text-sm font-medium flex items-center justify-center gap-2 hover:bg-white/20 transition-colors"
						style={{ color: '#ffffff' }}
					>
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
						</svg>
						Open Tool
					</button>
				</div>

				{/* Open Neo */}
			<div className="rounded-2xl p-8 shadow-xl flex flex-col" style={{ backgroundColor: 'rgb(38, 76, 81)', color: '#ffffff' }}>
				<div className="flex items-start gap-3 mb-6 flex-1">
					<div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
						<svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: '#ffffff' }}>
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
						</svg>
					</div>
					<div>
						<h2 className="text-2xl font-bold mb-2" style={{ color: '#ffffff' }}>Open Neo</h2>
						<p style={{ color: '#ffffff' }}>AI-powered venue research and proposal generation</p>
					</div>
				</div>
					<button 
						onClick={() => navigate('/tools/research-proposal')} 
						className="w-full bg-white/10 rounded-xl px-4 py-3 text-sm font-medium flex items-center justify-center gap-2 hover:bg-white/20 transition-colors"
						style={{ color: '#ffffff' }}
					>
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
						</svg>
						Open Tool
					</button>
				</div>

				{/* Flight Manifests Tool */}
				<div className="rounded-2xl p-8 shadow-xl flex flex-col" style={{ backgroundColor: 'rgb(38, 76, 81)', color: '#ffffff' }}>
					<div className="flex items-start gap-3 mb-6 flex-1">
						<div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
							<svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: '#ffffff' }}>
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
							</svg>
						</div>
						<div>
							<h2 className="text-2xl font-bold mb-2" style={{ color: '#ffffff' }}>Flight Manifests</h2>
							<p style={{ color: '#ffffff' }}>Upload & extract flight data from PDFs</p>
						</div>
					</div>
					<button
						onClick={() => navigate('/tools/flight-manifests')}
						className="w-full bg-white/10 rounded-xl px-4 py-3 text-sm font-medium flex items-center justify-center gap-2 hover:bg-white/20 transition-colors"
						style={{ color: '#ffffff' }}
					>
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
						</svg>
						Open Tool
					</button>
				</div>
			</div>

				{/* Active Events & Quick Access */}
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
					{/* Active Events */}
					<div className="lg:col-span-2">
						<h3 className="text-lg font-semibold mb-4" style={{ color: 'rgb(38, 76, 81)' }}>Active Events</h3>
						<div className="space-y-3">
							{loadingEvents ? (
								<div className="bg-background rounded-lg p-4 border" style={{ boxShadow: '0 4px 12px #161a2510' }}>
									<div className="flex items-center gap-4">
										<div className="w-12 h-12 bg-gray-100 rounded-lg animate-pulse shrink-0"></div>
										<div className="flex-1">
											<div className="h-4 bg-gray-100 rounded animate-pulse mb-2"></div>
											<div className="h-3 bg-gray-100 rounded animate-pulse w-1/2"></div>
										</div>
									</div>
								</div>
							) : events.length > 0 ? (
								events.slice(0, 6).map((event) => (
									<div 
										key={event.id} 
										className="bg-background rounded-lg p-4 border transition-all cursor-pointer group flex items-center gap-4"
										style={{ boxShadow: '0 4px 12px #161a2510' }}
										onClick={() => navigate(`/organization/events/${event.id}`)}
									>
										<div className="w-12 h-12 bg-gradient-to-br from-secondary-100 to-secondary-200 rounded-lg flex items-center justify-center shrink-0">
											<svg className="w-6 h-6 text-secondary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
											</svg>
										</div>
										<div className="flex-1 min-w-0">
											<h4 className="font-medium text-foreground truncate group-hover:text-secondary-600 transition-colors">{event.name}</h4>
											<p className="text-sm text-muted-foreground">Client: {event.client_name}</p>
										</div>
									</div>
								))
							) : (
								<div className="bg-background rounded-lg p-8 border text-center" style={{ boxShadow: '0 4px 12px #161a2510' }}>
									<div className="w-16 h-16 bg-gray-100 rounded-lg mx-auto mb-4 flex items-center justify-center">
										<svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
											<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
										</svg>
									</div>
									<h4 className="font-medium text-foreground mb-2">No Active Events</h4>
									<p className="text-sm text-muted-foreground mb-4">Create your first client and event to get started.</p>
									<button 
										onClick={() => navigate('/organization/clients')}
										className="text-sm text-primary-600 hover:text-primary-700 font-medium"
									>
										Manage Clients →
									</button>
								</div>
							)}
						</div>
					</div>

					{/* Quick Access */}
					<div>
						<h3 className="text-lg font-semibold mb-4" style={{ color: 'rgb(38, 76, 81)' }}>Quick Access</h3>
						<div className="bg-background rounded-xl p-6 border" style={{ boxShadow: '0 4px 12px #161a2510' }}>
							<div className="space-y-3">
							<button 
								onClick={() => navigate('/organization/venues')} 
								className="w-full flex items-center gap-4 p-3 rounded-lg hover:bg-muted/50 transition-colors text-left"
							>
								<div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center shrink-0">
									<svg className="w-5 h-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
									</svg>
								</div>
								<div>
									<div className="font-medium text-foreground">Venues</div>
									<div className="text-sm text-muted-foreground">Browse and manage venues</div>
								</div>
							</button>

								<button
									onClick={() => navigate('/organization/clients')}
									className="w-full flex items-center gap-4 p-3 rounded-lg hover:bg-muted/50 transition-colors text-left"
								>
									<div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center shrink-0">
										<svg className="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
											<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M9 20h6m-7-4a4 4 0 118 0v4H8v-4z" />
										</svg>
									</div>
									<div>
										<div className="font-medium text-foreground">Clients</div>
										<div className="text-sm text-muted-foreground">Manage client relationships</div>
									</div>
								</button>

								{/* Removed Brand Colors and Backgrounds */}

								<button
									onClick={() => navigate('/organization')}
									className="w-full flex items-center gap-4 p-3 rounded-lg hover:bg-muted/50 transition-colors text-left"
								>
									<div className="w-10 h-10 bg-secondary-100 rounded-lg flex items-center justify-center shrink-0">
										<svg className="w-5 h-5 text-secondary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
											<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
										</svg>
									</div>
									<div>
										<div className="font-medium text-foreground">Organization</div>
										<div className="text-sm text-muted-foreground">Team, brand, and settings</div>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</Container>

				{/* Modals */}
				{showAttachmentsManager && <AttachmentsManager onClose={() => navigate('/dashboard')} />}
				{/* Assets, templates, AI generator modals removed in post-refactor cleanup */}
			</div>
		);
} 